export const generateURL = (
  path: string,
  pathParams?: { [key: string]: string | number },
  queryParams?: { [key: string]: string | number }
): URL => {
  let interpolatedPath = path;

  // handle path parameters
  if (pathParams) {
    Object.keys(pathParams).forEach((key) => {
      const value = pathParams[key];
      // replace :key with the actual value
      interpolatedPath = interpolatedPath.replace(`:${key}`, String(value));
    });
  }

  const url = new URL(interpolatedPath);

  // handle query parameters
  if (queryParams) {
    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        url.searchParams.set(key, String(queryParams[key]));
      }
    });
  }

  return url;
};
